import * as React from "react";
import styled from "styled-components";
import useD365Form from "../../../hooks/d365-form/use-d365-form";

const Root = styled.div(({ hidden }) => ({
  marginTop: 40,
  display: hidden ? "none" : "block",
}));

function FreeTrialForm(props) {
  const { hidden, version, onSubmit } = props;
  const formId =
    version === 2
      ? "1514fe80-8aed-ee11-a204-000d3a14dcb8"
      : "cd0255bf-d415-ee11-8f6e-0022482b2538";
  const websiteId = "bH9gL5CgTEXeI7lOfYJDtzA5vZhSnshbap7glwz_yM8";
  const hostName = "2a768ee8dd2f4342b33eafb283a2318a.svc.dynamics.com";

  useD365Form({ formId, onSubmitAll: onSubmit });

  return (
    <Root hidden={hidden}>
      <div data-form-block-id={formId} />
      <div id="dbH9gL5CgTEXeI7lOfYJDtzA5vZhSnshbap7glwz_yM8" />
      <div
        className="d365-mkt-config"
        style={{ display: "none" }}
        data-website-id={websiteId}
        data-hostname={hostName}
      />
    </Root>
  );
}

export default FreeTrialForm;
